import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Button, Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const BedLinensSection = (): ReactElement => {
  const { t } = useTranslation('', { keyPrefix: '$local.$hpCopy' });

  return (
    <section className="base-section bed-linens-section main-hp hp-section">
      <div className="mod-wrap bg-right">
        <Link href={t('beddingLink')} className="module bedding clearfix">
          <div className="branding-hero">
            <div className="img-wrap-tall">
              <picture>
                <source
                  srcSet="/images/homepage/bedLinenSection/kem-bedding-mob.webp"
                  media="(max-width: 768px)"
                />
                <img
                  src="/images/homepage/bedLinenSection/kem-bedding-dsktp.webp"
                  alt="Bedding"
                  width={845}
                  height={977}
                />
              </picture>
            </div>
          </div>
          <div className="outer-wrap">
            <div className="inner-wrap">
              <div className="title">
                <div className="inner-title">
                  <h2>{t('beddingHeading')}</h2>
                  <p>{t('beddingText')}</p>
                  <Button ariaLabel={t('beddingCta')}>{t('beddingCta')}</Button>
                </div>
              </div>
              <div className="bedding-products">
                <div id="HP_bedding_bedding-set" className="bedding-product-wrap">
                  <picture>
                    <img
                      src="/images/homepage/bedLinenSection/kem-linen-dsktp-1.webp"
                      alt="Bedding category"
                      width={1020}
                      height={506}
                    />
                  </picture>
                </div>
              </div>
            </div>
          </div>
        </Link>
      </div>

      {/* Linens Section */}
      <div className="mod-wrap bg-left">
        <Link href={t('linensLink')} className="module linens clearfix">
          <div className="outer-wrap">
            <div className="inner-wrap">
              <div className="title">
                <div className="inner-title">
                  <h2>{t('linensHeading')}</h2>
                  <p>{t('linensText')}</p>
                  <Button ariaLabel={t('linensCta')}>{t('linensCta')}</Button>
                </div>
              </div>
            </div>
          </div>
          <div className="branding-hero">
            <div className="img-wrap-tall">
              <picture>
                <source
                  srcSet="/images/homepage/bedLinenSection/kem-linen-mob.webp"
                  media="(max-width: 768px)"
                />
                <img
                  src="/images/homepage/bedLinenSection/kem-linen-dsktp-2.webp"
                  alt="Linens"
                  width={1020}
                  height={715}
                />
              </picture>
            </div>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default BedLinensSection;
